<!-- Main Content -->
<div class="content md3-surface">
	<div class="layout-list-quickfilter md3-card-on-surface">
		<!-- Search Header -->
		<exg-search-bar (Search)="receiptTable.search($event)"
		                [placeholder]="getRessource('SearchHolder')"
		                class="span-layout">
			<ng-template #rightTemplate>
				<i (click)="receiptTable.loadData()" class="search-action fal fa-sync"></i>
				<app-exg-dropdown #VCDropDownFilter>
					<ng-template #hostTemplate>
						<i class="search-action fa-filter"
						   [class.fas]="appSvc.metaInfo.uiFilterAktiv(receiptTable.uiFilter, 1).length > 0"
						   [class.fal]="appSvc.metaInfo.uiFilterAktiv(receiptTable.uiFilter, 1).length === 0"></i>
					</ng-template>
					<ng-template #contentTemplate let-popup>
						<app-exg-filter #VCreceiptTableFilterControl [visibility]="popup.visibility !== 'hidden'"
						                (onActivateFilter)="receiptTable.pageChanged(1);popup.close()"
						                [MetaInfo]="receiptTable.MetaInfo"
						                [showFilter]="true" [uiFilter]="receiptTable.uiFilter"
						                [uiSort]="receiptTable.uiSort"></app-exg-filter>
					</ng-template>
				</app-exg-dropdown>
				<app-exg-dropdown>
					<ng-template #hostTemplate>
						<i class="search-action fa-sort-alt"
						   [class.fas]="appSvc.metaInfo.uiSortAktiv(receiptTable.uiSort).length > 0"
						   [class.fal]="appSvc.metaInfo.uiSortAktiv(receiptTable.uiSort).length === 0"></i>
					</ng-template>
					<ng-template #contentTemplate let-popup>
						<app-exg-filter #VCreceiptTableSortControl [visibility]="popup.visibility !== 'hidden'"
						                (onActivateFilter)="receiptTable.pageChanged(1);popup.close()"
						                [MetaInfo]="receiptTable.MetaInfo"
						                [showSort]="true" [uiFilter]="receiptTable.uiFilter"
						                [uiSort]="receiptTable.uiSort"></app-exg-filter>
					</ng-template>
				</app-exg-dropdown>
				<app-exg-dropdown>
					<ng-template #hostTemplate>
						<i class="search-action fa-binoculars"
						   [class.fas]="appSvc.metaInfo.uiFilterAktiv(receiptTable.uiFilter, 2).length > 0"
						   [class.fal]="appSvc.metaInfo.uiFilterAktiv(receiptTable.uiFilter, 2).length === 0"></i>
					</ng-template>
					<ng-template #contentTemplate let-popup>
						<app-exg-filter #VCreceiptTableSearchControl [visibility]="popup.visibility !== 'hidden'"
						                (onActivateFilter)="receiptTable.pageChanged(1);popup.close()"
						                [MetaInfo]="receiptTable.MetaInfo"
						                [showSearch]="true" [uiFilter]="receiptTable.uiFilter"
						                [uiSort]="receiptTable.uiSort"></app-exg-filter>
					</ng-template>
				</app-exg-dropdown>
				<i class="search-action fal fa-list"
				   [class.disabled]="receiptTable.newV2Table"
				   [class.c-green]="receiptTable.multiSelection"
				   (click)="receiptTable.toggleMultiSelection()"
				   [tooltip]="getRessource('TooltipToggleMultiSelection')"  flow="left">
				</i>
				<i class="search-action fal fa-gears"
				   [class.disabled]="!receiptTable.newV2Table"
				   (click)="openTableSettings($event)">
				</i>
				<exg-table-settings #tableDefinitionSettings
				                    [tableDef]="receiptTable.tableDefinition"
				                    [metaInfo]="receiptTable.MetaInfo"
				                    localStorageID="receiptTable">
				</exg-table-settings>
				<i class="search-action fa-table"
				   (click)="receiptTable.newV2Table = !receiptTable.newV2Table;"
				   [class.fas]="receiptTable.newV2Table"
				   [class.fal]="!receiptTable.newV2Table">
				</i>
			</ng-template>
		</exg-search-bar>
		<div class="content">
			<ng-container *ngIf="!receiptTable.newV2Table">
				<exg-data-table
            #VCreceiptTable
						[hidden]="layoutEditorVisible"
						(ItemSelect)="receiptTable.itemSelect($event)"
						(RowChange)="receiptTable.selectionChanged($event)"
						(RowDblClick)="openWorkspace($event)"
						[selectSource]="receiptTable.selectedRow"
						[allowMultiSelection]="receiptTable.multiSelection"
						[allowSingleSelection]="!receiptTable.multiSelection"
						[displayState]="receiptTable.state"
						[rowSource]="receiptTable.data"
						containerClass="grid cols-17"
						[selectKey]="receiptTable.selectKey">
					<ng-template #headerTemplate>
						<div class="span-3">
							<p>
								<strong>
									{{enumSvc.getFieldCaption('Receipt', 'rcptOrderNumber')}}
									&nbsp;({{enumSvc.getFieldCaption('Receipt', 'rcpt_enmIdent_ReceiptStatus')}})
								</strong>
							</p>
							<p><strong>{{enumSvc.getFieldCaption('Company', 'compName')}}</strong></p>
						</div>
						<div class="span-2">
							<p><strong>{{enumSvc.getFieldCaption('Auftrag', 'auNr')}}</strong></p>
							<p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')}}</strong></p>
						</div>
						<div class="span-2">
							<p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorgNr')}}</strong></p>
							<p><strong>
								{{enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangTyp')}}</strong></p>
						</div>
						<div class="span-3">
							<p> <strong>{{enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')}}</strong></p>
							<p>
								<strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')}}</strong>
							</p>
						</div>
						<div class="span-3">
							<p>
								<strong>{{enumSvc.getFieldCaption('Auftrag', 'auAuftraggeber')}}</strong>
							</p>
							<p>
								<strong>
									{{enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')}}
									({{enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')}})
								</strong>
							</p>
						</div>
						<div class="span-2">
							<p> <strong>{{enumSvc.getFieldCaption("All", "%CRU")}}</strong></p>
							<p> <strong>{{enumSvc.getFieldCaption("All", "%CRD")}}</strong></p>
						</div>
						<div class="span-2">
							<p> <strong>{{enumSvc.getFieldCaption("All", "%LCU")}}</strong></p>
							<p> <strong>{{enumSvc.getFieldCaption("All", "%LCD")}}</strong></p>
						</div>
					</ng-template>
					<ng-template #rowTemplate let-row>
						<div class="span-3">
							<p class="typo-small">
								<strong>
									{{row.rcptOrderNumber}}
									&nbsp;({{enumSvc.getEnumerationText('ReceiptStatus', row['rcpt_enmIdent_ReceiptStatus'])}})
								</strong>
							</p>
							<p>
								{{row.compName || '-'}}
							</p>
						</div>
						<div class="span-2">
							<p>{{row.auNr}}</p>
							<p>{{row.aueSchadenNr}}</p>
						</div>
						<div class="span-2">
							<p>{{row.vorgNr}}&nbsp;({{enumSvc.getEnumerationText('VorgangStatus', row['vorg_enmIdent_VorgangStatus'])}})</p>
							<p>{{enumSvc.getEnumerationText('VorgangTyp', row['vorg_enmIdent_VorgangTyp'])}}</p>
						</div>
						<div class="span-3">
							<p>{{row.aueVersicherungsnehmer}}</p>
							<p>{{row.aueSchadenOrt || '-'}}</p>
						</div>
						<div class="span-3">
							<p>{{row.auAuftraggeber}}</p>
							<p>
								{{enumSvc.getEnumerationText(row['aue_enmName_SchadenArt'], row['aue_enmIdent_SchadenArt'])}}
								&nbsp;({{enumSvc.getEnumerationText(row['aue_enmName_Versicherungsart'], row['aue_enmIdent_Versicherungsart'])}})
							</p>
						</div>
						<div class="span-2">
							<p>{{row.rcptCRU}}&nbsp;</p>
							<p>{{row.rcptCRD | excDate: getGlobal('DateTimeFormatShort')}}&nbsp;</p>
						</div>
						<div class="span-2">
							<p>{{row.rcptLCU}}&nbsp;</p>
							<p>{{row.rcptLCD | excDate: getGlobal('DateTimeFormatShort')}}&nbsp;</p>
						</div>
					</ng-template>
				</exg-data-table>
			</ng-container>
			<ng-container *ngIf="receiptTable.newV2Table">
				<exg-table #VCreceiptTableV2
				           (RowDblClick)="openWorkspace($event)"
				           (RowChange)="receiptTable.selectionChanged($event)"
				           (FilterActivation)="receiptTable.loadData()"
				           [selectKey]="receiptTable.selectKey"
				           [rowSource]="receiptTable.data"
				           [tableDef]="receiptTable.tableDefinition"
				           [distinctTableName]="'Receipts'"
				           [metaInfo]="receiptTable.MetaInfo"
				           [displayState]="receiptTable.state"
				           class="content"
				           [allowMultiSelection]="false"
				           [allowSingleSelection]="true"
				           (loadDistinct)="receiptTable.getDistinctData($event)"
				           [distinctData]="receiptTable.distinctData">
				</exg-table>
			</ng-container>
			<div class="drawer-container right app-table-drawer">
				<div [ngClass]="{'visible': rightDrawerVisible }"
				     class="drawer-content md3-card-on-surface app-space-right_0">
					<div class="content width-500 ">
						<ng-container *ngIf="appSvc.table.isEmpty(receiptTable) || (appSvc.table.isLoading(receiptTable) || appSvc.table.isLoading(receiptTableDrawer))">
							<div *ngIf="appSvc.table.isEmpty(receiptTable) && !appSvc.table.isLoading(receiptTable) &&  !appSvc.table.isLoading(receiptTableDrawer)" class="splash empty">
								<p>{{getRessource('zeroRows')}}</p>
							</div>
							<div *ngIf="appSvc.table.isLoading(receiptTable) || (appSvc.table.isLoading(receiptTable) || appSvc.table.isLoading(receiptTableDrawer))" class="splash loading">
								<div class="spinner">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</ng-container>
						<app-exg-tab-v2 #VCrightTabControl
						                [hidden]="appSvc.table.isEmpty(receiptTable) || (appSvc.table.isLoading(receiptTable) || appSvc.table.isLoading(receiptTableDrawer))"
										        (tabchange)="rightTabs_tabChange($event)" [header]="rightTabs">
							<ng-template #pages>
								<!-- 1 - Details-->
								<div class="app-subarea app-space-right content">
									<app-receipt-statement-details #VCreceipt
									                               *ngIf="!receiptTableDrawer.isLoading"
									                               [workspace]="{
									                                  receiptData: receiptTableDrawer.data
									                               }"
																		             [details]="receiptTableDrawer.details"
																		             [canEdit]="false">
									</app-receipt-statement-details>
								</div>
							</ng-template>
						</app-exg-tab-v2>
					</div>
				</div>
			</div>
		</div>
		<div class="app-drawer">
			<i (click)="toggleRightDrawer()"
			   [class.fal]="!rightDrawerVisible"
			   [class.fas]="rightDrawerVisible"
			   [class.disabled]="appSvc.isTableLoading(receiptTable) || appSvc.isTableEmpty(receiptTable)|| receiptTable.multiSelection"
			   class="fa-info app-drawer-icon ">
			</i>
			<i class="search-filter-seperator"></i>
			<ng-container *ngIf="!rightDrawerVisible  || (rightDrawerVisible && VCrightTabControl.selectedtab === 0)">
				<i (click)="openCheckView();"
				   [tooltip]="getRessource('openCheckview')" flow="left"
				   class="search-filter-action fal fa-chevron-right"
				   [class.disabled]="appSvc.isTableLoading(receiptTable) || appSvc.isTableEmpty(receiptTable)|| receiptTable.multiSelection">
				</i>
				<i class="search-filter-seperator"></i>
				<i (click)="openTaskWorkspace();" [tooltip]="getRessource('openWorkspace')" flow="left"
				   class="search-filter-action fal fa-clipboard"
				   [class.disabled]="appSvc.isTableLoading(receiptTable) || appSvc.isTableEmpty(receiptTable) || receiptTable.multiSelection">
				</i>
				<i class="search-filter-seperator"></i>
				<i (click)="switchToReceiptModule();"
				   *ngIf="excSecurity.isFeatured('STATEMENTSWITCH') && excSecurity.isFeatured('RECEIPTCREATE')"
				   [tooltip]="getRessource('switchToReceipt')" flow="left"
				   class="search-filter-action fal fa-file-invoice"
				   [class.disabled]="(
														    appSvc.isTableLoading(receiptTable)
														    || appSvc.isTableEmpty(receiptTable)
														    || receiptTable.multiSelection
														    || appSvc.isTableLoading(receiptTableDrawer)
															) || (
																receiptTableDrawer.data
															  && !receiptTableDrawer.data.rcpt_fileStreamID
															)">
				</i>
			</ng-container>
		</div>
		<exg-pager class="span-layout" *ngIf="!init"
		           (PageChange)="receiptTable.pageChanged($event)"
		           [pagingSource]="receiptTable.paging">
			<ng-template #leftTemplate>
			</ng-template>
			<ng-template #rightTemplate>
				<div class="app-pager-chips">
					<app-exg-filter-chips #VCFilterChips
					                      [inputDataTable]="receiptTable"
					                      [VCFilterControl]="{ VCFilter: VCreceiptTableFilterControl, VCSearch: VCreceiptTableSearchControl, VCSort: VCreceiptTableSortControl}">
					</app-exg-filter-chips>
				</div>
			</ng-template>
		</exg-pager>
	</div>
</div>
